'use client';

import {useEffect, useState} from 'react';

export const useCountdown = (
    targetDate: Date | string | number,
    options = {doubleDigits: true},
) => {
    const calcDuration = () => {
        const end = new Date(targetDate).getTime();
        const now = new Date().getTime();
        return Math.max(0, end - now);
    };

    const [duration, setDuration] = useState(calcDuration());

    useEffect(() => {
        const interval = setInterval(() => {
            setDuration(calcDuration());
        }, 1000);

        return () => clearInterval(interval);
    }, [targetDate]);

    if (options.doubleDigits) {
        return Object.fromEntries(
            Object.entries(getTimeComponents(duration)).map(([key, value]) => [
                key,
                getDoubleDigit(value),
            ]),
        );
    }

    return getTimeComponents(duration);
};

export const getTimeComponents = (duration: number) => {
    const days = duration / (1000 * 60 * 60 * 24);
    const hours = (days % 1) * 24;
    const minutes = (hours % 1) * 60;
    const seconds = (minutes % 1) * 60;

    return {
        days: Math.floor(days),
        hours: Math.floor(hours),
        minutes: Math.floor(minutes),
        seconds: Math.floor(seconds),
    };
};

const getDoubleDigit = (digit: number) => {
    return String(digit).padStart(2, '0');
};
